import {observable} from "mobx";
import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import FirebaseMyAccountFunctionsService
    from "../../../../services/firebase/functions/FirebaseMyAccountFunctionsService";
import {isMobile} from "react-device-detect";

// @ts-ignore
import welcome from "../../../../assets/images/onBoardingArrows/onboarding-welcome-stars.svg";
// @ts-ignore
import profile_arrow from "../../../../assets/images/onBoardingArrows/profile-arrow.svg";
// @ts-ignore
import plans_arrow from "../../../../assets/images/onBoardingArrows/plans-arrow.svg";
// @ts-ignore
import payment_arrow from "../../../../assets/images/onBoardingArrows/payment-arrow.svg";
// @ts-ignore
import bank_arrow from "../../../../assets/images/onBoardingArrows/bank_account-arrow.svg";
// @ts-ignore
import notifications_arrow from "../../../../assets/images/onBoardingArrows/notification-arrow.svg";
// @ts-ignore
import coverage_arrow from "../../../../assets/images/onBoardingArrows/add_coverage-arrow.svg";


// @ts-ignore
import welcome_mobile from "../../../../assets/images/mobileOmBoarding/1.png";
// @ts-ignore
import profile_mobile from "../../../../assets/images/mobileOmBoarding/2.png";
// @ts-ignore
import plans_mobile from "../../../../assets/images/mobileOmBoarding/3.png";
// @ts-ignore
import manage_plans_mobile from "../../../../assets/images/mobileOmBoarding/4.png";
// @ts-ignore
import payment_method_mobile from "../../../../assets/images/mobileOmBoarding/5.png";
// @ts-ignore
import bank_account_mobile from "../../../../assets/images/mobileOmBoarding/6.png";
// @ts-ignore
import notifications_mobile from "../../../../assets/images/mobileOmBoarding/7.png";
// @ts-ignore
import coverage_mobile from "../../../../assets/images/mobileOmBoarding/8.png";
import MixPanelAnalyticsService from "../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsAccountEvents} from "../../../../services/Analytics/AnalyticsAccountEvents";

const TEXTS =  {
    web: {
        profile: "Here you can find a basic overview of your current balances.",
        plans: "Manage your plans, update amount or cancel a plan.",
        payment: "Here you can see the card charged with your monthly fee.",
        bank: "This section shows the bank account you connected when you applied.",
        notification: "Important updates regarding the activity in your account will appear here.",
        add: "Hit the \"Add loan\" to apply for additional plans. You can now go to your account."
    },
    mobile: {
        plans: "Here you can see an overview of the different plans you are subscribed to."
    }
}



export default class AccountOnBoardingStore extends ApiCallObservable<any> {
    @observable public _currentStep: number = -1;
    @observable public finishedOnBoarding: boolean;

    public steps = [
        {
            position: {
                top: "25%",
                left: "150%"
            },
            header: "Your profile",
            text: TEXTS.web.profile,
            mobileImage: profile_mobile,
            image: profile_arrow,
            imagePosition: {
                top: "45%",
                left: "110%"
            }
        },
        {
            position: {
                top: "35%",
                left: "115%"
            },
            header: isMobile? "Plans" :  "Manage plan",
            text: isMobile?  TEXTS.mobile.plans : TEXTS.web.plans ,
            mobileImage: plans_mobile,
            image: plans_arrow,
            imagePosition: {
                top: "7%",
                left: "105%"
            }
        },
        {
            position: {
                right: "98%",
                bottom: "170%"
            },
            header: "Payment method",
            text: TEXTS.web.payment ,
            mobileImage: payment_method_mobile,
            image: payment_arrow,
            imagePosition: {
                bottom: "150%",
                left: "10%"
            }
        },
        {
            position: {
                right: "98%",
                bottom: "170%"
            },
            header: "Bank account",
            text: TEXTS.web.bank ,
            mobileImage: bank_account_mobile,
            image: bank_arrow,
            imagePosition: {
                bottom: "150%",
                left: "10%"
            }
        },
        {
            position: {
                right: "5em",
                top: "7em"
            },
            header: "Notification",
            text: TEXTS.web.notification,
            mobileImage: notifications_mobile,
            image:  notifications_arrow,
            imagePosition: {
                right: "5em",
                top: "0"
            }
        },
        {
            position: {
                bottom: "9em",
                left: "20em"
            },
            header: "Add loan",
            text: TEXTS.web.add,
            mobileImage: coverage_mobile,
            image: coverage_arrow,
            imagePosition: {
                bottom: "2em",
                left: "25em"
            }
        },
    ];

    constructor() {
        super();
        if(isMobile) {
            const managePlans = {
                header: "Manage plan",
                text: "Manage your plans, update amount or cancel a plan.",
                position: {
                    top: "35%",
                    left: "40%"
                },
                mobileImage: manage_plans_mobile,
                image: welcome,
                imagePosition: {
                    top: "21%",
                    left: "35%"
                }
            };
            this.steps.splice(2, 0, managePlans);
        }
    }


    get currentStep() {
        return this._currentStep;
    }

    public setCurrentStep = (newStep: number) => {
        this._currentStep = newStep;
    };

    public finish = () => {
        this._currentStep = -2;
        this.finishedOnBoarding = true;
        MixPanelAnalyticsService.track(AnalyticsAccountEvents.onBoardingSkipped);
        this.updateUserOnBoarding();

    };

    public next = () => {
        if(this._currentStep + 1 >= this.steps.length) {
            this._currentStep = -2;
            this.finishedOnBoarding = true;
            MixPanelAnalyticsService.track(AnalyticsAccountEvents.onBoardingEnded);
            this.updateUserOnBoarding();
        }else {
            this._currentStep++;
        }
    };

    public getOnBoardingData = () => {
        if(this.currentStep === -1) {
            MixPanelAnalyticsService.track(AnalyticsAccountEvents.onBoardingStarted);
            return {
                header: "Welcome to your account",
                text: "To hop on a quick tutorial, hit ”Start”.",
                position: {
                    top: "35%",
                    left: "40%"
                },
                mobileImage: welcome_mobile,
                image: welcome,
                imagePosition: {
                    top: "21%",
                    left: "33%"
                }
            }
        }
        return this.steps[this.currentStep];
    }

    public async updateUserOnBoarding() {
        const response = await FirebaseMyAccountFunctionsService.markOnBoardingAsSeen();
        if (!response.ok) {
            console.log(response);
        }
    }
}



// WEBPACK FOOTER //
// ./src/scenes/MyAccount/state/mobx/AccountOnBoardingStore.ts